// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"97":"4e365551","262":"93a255a6"}[chunkId] + ".chunk.css";
};